export default __webpack_public_path__ + "static/2460-94715e4f0d372390c3555eaa9ee27c95.gif";